import React from 'react';
import PropTypes from 'prop-types';
import { RootProvider, useI18n } from '@jarvis/react-portal-addons';
import { Container, Subtitle, Title } from './styles';
import resources from '../../assets/locale/index';

const InvitationErrorPageContent = () => {
  const { t } = useI18n();
  return (
    <Container data-testid="invitation-error-page">
      <Title className="title-regular" data-testid="invitation-error-page-title">
        {t('invitationErrorPage.title')}
      </Title>
      <Subtitle className="body-large" data-testid="invitation-error-page-subtitle">
        {t('invitationErrorPage.subtitle')}
      </Subtitle>
    </Container>
  );
};

const InvitationErrorPage = props => {
  const { shell, stack } = props;
  const localization = shell?.localization || {};

  return (
    <RootProvider
      stack={stack}
      shell={shell}
      localization={localization}
      resources={resources}
    >
      <InvitationErrorPageContent />
    </RootProvider>
  );
};

InvitationErrorPage.defaultProps = {
  shell: {},
};

InvitationErrorPage.propTypes = {
  shell: PropTypes.objectOf(PropTypes.any),
  stack: PropTypes.number.isRequired,
};

export default InvitationErrorPage;
